export default __webpack_public_path__ + "static/media/icon-volume.9769ad1d.svg";